export class ComponentUtil {
  static parents(target, component) {
    let _parent = component.$parent;
    while (true) {
      if (_parent instanceof target) {
        return _parent;
      }
      _parent = _parent.$parent;
      if (!_parent) {
        return null;
      }
    }
  }
}
